// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.About_container__-rPyx {
  display: flex;
  flex-direction: column;
  background-color: var(--color-primary-9);
  padding: 0 5rem;
}
.About_container__mid__khjGm {
  max-width: 100vw;
  padding: 5rem;
}
.About_container__-rPyx p {
  font-size: 2.4rem;
  line-height: 4.3rem;
  padding: 0 5rem 5rem 5rem;
}
.About_container__team__oqfe9 {
  display: flex;
  justify-content: center;
  width: 100%;
}
.About_container__team__img__BnoIv {
  width: 60%;
  height: 40rem;
  border-radius: 1.6rem;
  object-fit: cover;
  margin-top: 2rem;
  margin-bottom: 4rem;
}
@media only screen and (max-width: 43.75em) {
  .About_container__team__img__BnoIv {
    width: 85%;
  }
}
@media only screen and (max-width: 31.25em) {
  .About_container__team__img__BnoIv {
    width: 100%;
    height: 30rem;
  }
}
@media only screen and (max-width: 25em) {
  .About_container__team__img__BnoIv {
    height: 20rem;
  }
}

.About_content__grid__HDIu\\+ {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 5rem;
  margin-bottom: 5rem;
}
@media only screen and (max-width: 50em) {
  .About_content__grid__HDIu\\+ {
    grid-template-columns: 1fr;
  }
  .About_content__grid__HDIu\\+ > :first-child {
    grid-row: 2/3;
  }
}
.About_content__grid__HDIu\\+ > :first-child img {
  object-fit: cover;
  border-radius: 1.6rem;
  height: 100%;
  width: 100%;
}
@media only screen and (max-width: 50em) {
  .About_content__grid__HDIu\\+ > :first-child img {
    height: 60rem;
  }
}
.About_content__grid__HDIu\\+ > :last-child {
  background-color: var(--color-primary-3);
  padding: 3rem;
  border-radius: 1.6rem;
}
.About_content__grid__2__9bZl5 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 3.5rem;
  margin-bottom: 10rem;
}
@media only screen and (max-width: 50em) {
  .About_content__grid__2__9bZl5 {
    grid-template-columns: repeat(2, 1fr);
    row-gap: 8.5rem;
  }
}
@media only screen and (max-width: 37.5em) {
  .About_content__grid__2__9bZl5 {
    grid-template-columns: 1fr;
  }
}
.About_content__grid__2__card__jD\\+ZJ {
  background-color: var(--color-white);
  border-radius: 0.8rem;
  box-shadow: 0px 6px 60px 0px rgba(0, 0, 0, 0.08);
  padding: 5rem;
  position: relative;
}

.About_join__m2Mtv {
  width: 100%;
  background-color: var(--color-dark);
  padding: 7.5rem 12rem;
  margin: 3rem 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.About_join__btn__31Dmv {
  display: flex;
  gap: 3rem;
  margin: 3rem 0;
}
@media only screen and (max-width: 37.5em) {
  .About_join__btn__31Dmv {
    flex-direction: column;
  }
}
.About_join__btn__icon__yEDOj {
  height: 2.2rem;
  margin-right: 1rem;
}

.About_testimonialImg__kw-8h {
  position: absolute;
  left: 40%;
  bottom: -5rem;
}
.About_testimonialImg__kw-8h img {
  width: 10rem;
  border-radius: 50%;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/LandingPage/About.module.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,sBAAA;EACA,wCAAA;EACA,eAAA;AADJ;AAGI;EACI,gBAAA;EACA,aAAA;AADR;AAII;EACI,iBAAA;EACA,mBAAA;EACA,yBAAA;AAFR;AAKI;EACI,aAAA;EACA,uBAAA;EACA,WAAA;AAHR;AAKQ;EACI,UAAA;EACA,aAAA;EACA,qBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AAHZ;AAIY;EAPJ;IAQQ,UAAA;EADd;AACF;AAGY;EAXJ;IAYQ,WAAA;IACA,aAAA;EAAd;AACF;AAEY;EAhBJ;IAiBQ,aAAA;EACd;AACF;;AAMI;EACI,aAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AAHR;AAKQ;EANJ;IAOQ,0BAAA;EAFV;EAOM;IAEQ,aAAA;EAJd;AAJF;AAUY;EACI,iBAAA;EACA,qBAAA;EACA,YAAA;EACA,WAAA;AAHhB;AAKgB;EANJ;IAOQ,aAAA;EAFlB;AACF;AAMQ;EACI,wCAAA;EACA,aAAA;EACA,qBAAA;AAJZ;AAQI;EACI,aAAA;EACA,qCAAA;EACA,WAAA;EACA,oBAAA;AANR;AAQQ;EANJ;IAOQ,qCAAA;IACA,eAAA;EALV;AACF;AAOQ;EAXJ;IAYQ,0BAAA;EAJV;AACF;AAMQ;EACI,oCAAA;EACA,qBAAA;EACA,gDAAA;EACA,aAAA;EACA,kBAAA;AAJZ;;AAWA;EACC,WAAA;EACA,mCAAA;EACA,qBAAA;EACG,cAAA;EAEH,aAAA;EACG,sBAAA;EACH,mBAAA;EACA,uBAAA;AATD;AAWI;EACI,aAAA;EACA,SAAA;EACA,cAAA;AATR;AAWQ;EALJ;IAMQ,sBAAA;EARV;AACF;AAUQ;EACI,cAAA;EACA,kBAAA;AARZ;;AAaA;EACI,kBAAA;EACA,SAAA;EACA,aAAA;AAVJ;AAYI;EACI,YAAA;EACA,kBAAA;AAVR","sourcesContent":["@import '../variables/breakpoints';\n\n.container {\n    display: flex;\n    flex-direction: column;\n    background-color: var(--color-primary-9);\n    padding: 0 5rem;\n\n    &__mid {\n        max-width: 100vw;\n        padding: 5rem;\n    }\n\n    p {\n        font-size: 2.4rem;\n        line-height: 4.3rem;\n        padding: 0 5rem 5rem 5rem;\n    }\n\n    &__team {\n        display: flex;\n        justify-content: center;\n        width: 100%;\n\n        &__img {\n            width: 60%;\n            height: 40rem;\n            border-radius: 1.6rem;\n            object-fit: cover;\n            margin-top: 2rem;\n            margin-bottom: 4rem;\n            @media only screen and (max-width: $bp-700) {\n                width: 85%;\n            }\n\n            @media only screen and (max-width: $bp-500) {\n                width: 100%;\n                height: 30rem;\n            }\n\n            @media only screen and (max-width: $bp-400) {\n                height: 20rem;\n            }\n        }\n    }\n}\n\n.content {\n\n    &__grid {\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n        gap: 5rem;\n        margin-bottom: 5rem;\n\n        @media only screen and (max-width: $bp-800) {\n            grid-template-columns: 1fr;\n        }\n\n        \n\n        & > :first-child {\n            @media only screen and (max-width: $bp-800) {\n                grid-row: 2/3;\n            }\n            img {\n                object-fit: cover;\n                border-radius: 1.6rem;\n                height: 100%;\n                width: 100%;\n\n                @media only screen and (max-width: $bp-800) {\n                    height: 60rem;\n                }\n            }\n        }\n\n        & > :last-child {\n            background-color: var(--color-primary-3);\n            padding: 3rem;\n            border-radius: 1.6rem;\n        }\n    }\n\n    &__grid__2 {\n        display: grid;\n        grid-template-columns: repeat(3, 1fr);\n        gap: 3.5rem;\n        margin-bottom: 10rem;\n\n        @media only screen and (max-width: $bp-800) {\n            grid-template-columns: repeat(2, 1fr);\n            row-gap: 8.5rem;\n        }\n\n        @media only screen and (max-width: $bp-600) {\n            grid-template-columns: 1fr;\n        }\n\n        &__card {\n            background-color: var(--color-white);\n            border-radius: 0.8rem;\n            box-shadow: 0px 6px 60px 0px rgba(0, 0, 0, 0.08);\n            padding: 5rem;\n            position: relative;\n            // display: grid;\n            // grid-template-columns: 1fr;        \n        }\n    }\n}\n\n.join {\n\twidth: 100%;\n\tbackground-color: var(--color-dark);\n\tpadding: 7.5rem 12rem;\n    margin: 3rem 0;\n\n\tdisplay: flex;\n    flex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\n    &__btn {\n        display: flex;\n        gap: 3rem;\n        margin: 3rem 0;\n\n        @media only screen and (max-width: $bp-600) {\n            flex-direction: column;\n        }\n\n        &__icon {\n            height: 2.2rem;\n            margin-right: 1rem;\n        }\n    }\n}\n\n.testimonialImg {\n    position: absolute;\n    left: 40%;\n    bottom: -5rem;\n\n    img {\n        width: 10rem;\n        border-radius: 50%;               \n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `About_container__-rPyx`,
	"container__mid": `About_container__mid__khjGm`,
	"container__team": `About_container__team__oqfe9`,
	"container__team__img": `About_container__team__img__BnoIv`,
	"content__grid": `About_content__grid__HDIu+`,
	"content__grid__2": `About_content__grid__2__9bZl5`,
	"content__grid__2__card": `About_content__grid__2__card__jD+ZJ`,
	"join": `About_join__m2Mtv`,
	"join__btn": `About_join__btn__31Dmv`,
	"join__btn__icon": `About_join__btn__icon__yEDOj`,
	"testimonialImg": `About_testimonialImg__kw-8h`
};
export default ___CSS_LOADER_EXPORT___;
